import getStore from '../../../store';
import { navigateTo } from '../../../store/actions/navigateTo';
import { getCurrentLocation } from '../../../store/selectors';
import { createSearchInitiatedFrom } from '../../../store/actions/config';

export function ensureOnSearchPage(queryString = ''): boolean {
  const store = getStore();
  const currentPage = getCurrentPage(store);
  if (currentPage !== '/search') {
    navigateTo('/search' + queryString, store);
    return false;
  }
  return true;
}

export function getLastPageSegment(store: any): string {
  const currentPage = getCurrentPage(store);

  return currentPage.substring(currentPage.lastIndexOf('/') + 1);
}

export function setSearchPath(): void {
  const store = getStore();
  const currentPage = getCurrentPage(store);
  store.dispatch(createSearchInitiatedFrom(currentPage));
}

function getCurrentPage(store: any): string {
  const state = store.getState();
  const { pathname: currentPage } = getCurrentLocation(state);
  return currentPage;
}
